import React from "react";

import Dashboard from "../../Components/eventScheduler/Dashboard";


const EventScheduler = () => {
    return(
        <>
                <Dashboard />
        </>
    )
}

export default EventScheduler;